// константы ключей и сохранения в localStorage

export const LOCALSTOR_TOURIST_KEY = 'cruise.tourist'
export const LOCALSTOR_BOOK_KEY = 'cruise.book'
export const LOCALSTOR_BC = 'cruiseBC'
const SUTKI = 24 * 3600 // если круизные ключи прожили больше суток, считаем устаревшими


export const save_localStorage = (key, vals) => {
    const upd = Math.floor(Date.now() / 1000)
    const to_save = {...vals, upd}
    const json = JSON.stringify(to_save)
    try {
        localStorage.setItem(key, json)
    }catch (e) {
        console.error('save_localStorage', key, e)
    }
}

export const clean_cruise_localStorage = () => {
    Object.keys(localStorage).forEach(key => {
        if (/^cruise/.test(key)) {
            let remove = true
            let now = Date.now() / 1000
            try {
                const str = window.localStorage.getItem( key )
                if (str) {
                    let all = JSON.parse( str )
                    if (all && "object" === typeof(all) 
                        && "number" === typeof(all.upd) 
                        && now - all.upd < SUTKI) {
                        remove = false
                    }
                }
            } catch (e) {
                console.error('clean_cruise_localStorage', key, e)
            }
            if (remove) {
                localStorage.removeItem(key)    
            }
//console.log(key, remove ? 'remove' : 'SAVE')
        } else if ("undefined" === key) {
            localStorage.removeItem(key)
        }
    })
}
